class LoginUser {
  username;
  password;
  mfaCode;
}

export default LoginUser;
